import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {
	bruttoProductionList: [],
};

const reducerMap = {
	[types.SET_BRUTTO_PRODUCTION_LIST]: (state, { payload }) => {
		const { bruttoProductionList } = payload;
		return {
			...state,
			bruttoProductionList,
		};
	},
};

export default handleActions(reducerMap, initialState);
